<template>
  <sui-page>
    <sui-page-header title="내용 조회" />
    <sui-page-contents>
      <div class="comm_title_wrap">
        <!-- 기본정보 -->
        <h4>{{ $t('MSG_TIT_DEFAULT_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <!-- 제목 -->
            <sui-input-label :label="$t('MSG_TIT_TTL')" />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ approvalTitle }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <!-- 수정자 -->
            <sui-input-label :label="$t('MSG_TXT_MDFC_USR')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ modifierSummary }}
            </div>
          </div>
          <div class="col-xs-1">
            <!-- 수정일시 -->
            <sui-input-label :label="$t('MSG_TXT_MDFC_DTM')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ previousApprovalContentChangedDTM | dateformatToClient }}
            </div>
          </div>
        </div>
      </div>
      <div class="comm_title_wrap">
        <!-- 이전 본문 정보 -->
        <h4>{{ $t('MSG_TIT_PREV_TBAB_INFO') }}</h4>
      </div>
      <div>
        <sui-web-editor
          ref="webEditor00015"
          class="width100"
          :isViewer="true"
        />
      </div>
    </sui-page-contents>
    <!-- Page Footer -->
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <!-- 확인 -->
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickConfirm"
        >
          {{ $t('MSG_BTN_CFRM') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CML_00015', // eslint-disable-line vue/name-property-casing
  filters: {
    /**
     * 필터~
     */
    dateformatToClient(value) {
      const result = utils.dateformatToClient(value);
      return utils.isDate(result) ? result : '-';
    },
  },
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageInitialData: {
      type: Object,
      required: true,
      default() {
        return {
          approvalUid: '',
          approvalOrder: '',
        };
      },
    },
  },
  data() {
    return {
      approvalTitle: '',
      previousApprovalContentChangedDTM: '', // 수정일시
      modifierSummary: '',
    };
  },
  mounted() {
    if (utils.trim(this.pageInitialData.approvalUid) === '' || utils.trim(this.pageInitialData.approvalOrder) === '') {
      // '{0}은(는) 필수 항목입니다.'
      utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), utils.strFormat(this.$t('MSG_ALT_NCELL_REQUIRED_ITEM'), 'approvalId, approvalOrder'), null, () => {
        this.closePagePopup();
      });
    } else {
      this.loadData();
    }
  },
  created() {
  },
  methods: {
    /**
     * 세션 langId 와 displayLangId 를 비교하여 두 개의 값중 하나를 return
     */
    getDisplayText(displayLangId = '', localTextValue = '', globalTextValue = '') {
      return this.$store.getters.userInfo.langId === displayLangId ? localTextValue : globalTextValue;
    },
    /**
     * approvalUid 에 해당하는 결재 상세 데이터 조회
     */
    loadData() {
      http.request(this.contextPageId, 'DTS_CML_00018', {
        path: {
          'approval-uid': this.pageInitialData.approvalUid,
          'approval-order': this.pageInitialData.approvalOrder,
        },
      }).then(res => {
        this.approvalTitle = res.data.approvalTitle;
        // 수정자
        const modifier = utils.find(res.data.approvalUserList, { approvalOrder: this.pageInitialData.approvalOrder });
        this.modifierSummary = `${this.getDisplayText(modifier.userDisplayLanguageId, modifier.approvalUserName, modifier.approvalUserGlobalName)}(${modifier.approvalUserEmail.replace(/@.+/, '')}) / ${this.getDisplayText(modifier.userDisplayLanguageId, modifier.approvalDepartmentName, modifier.approvalDepartmentEnglishName)}`;
        this.previousApprovalContentChangedDTM = res.data.previousApprovalContentChangedDTM;
        this.$refs.webEditor00015.setHtml(res.data.previousApprovalContent);
      });
    },
    /**
     * '적용' 버튼 click event handler
     */
    onClickConfirm() {
      this.closePagePopup('');
    },
  },
};
</script>
<style scoped>
</style>
